import { useAuth0 } from '@auth0/auth0-react';
import { useAtomValue } from 'jotai';
import { useCallback } from 'react';

import { getElectionsContaining } from '@/apis/elections';
import { ElectionRecordResult } from '@/types';
import { domainCodeAtom } from '@australiangreens/ag-internal-components';
import { labelSorting } from '@/util/labelSorting';

export const useLookupElections = (hasElectorates?: boolean) => {
  const { getAccessTokenSilently } = useAuth0();
  const domainCode = useAtomValue(domainCodeAtom);

  return useCallback(
    async (lookupValue: string) => {
      const token = await getAccessTokenSilently();

      return (await getElectionsContaining(token, lookupValue, domainCode, hasElectorates))
        .map((x) => {
          return {
            id: x.id,
            label: x.name,
          } as ElectionRecordResult;
        })
        .sort(labelSorting);
    },
    [domainCode, getAccessTokenSilently, hasElectorates]
  );
};
